import React from 'react';
import LineChart from '../../../charts/LineChart08';
import { useState, useEffect } from 'react';

// Import utilities
import { tailwindConfig, hexToRGB } from '../../../utils/Utils';

function FilterTrendCard({data}) {

  const [chartData, setChartData] = useState(null)
  const [total, setTotal] = useState(null)
  const [popularity, setPopularity] = useState(null)

  useEffect(() => {
    if(data.hasOwnProperty('labels') && data.hasOwnProperty('values')) {
      setPopularity(data.popularity)
      setTotal(data.total)
      var color = '#f43f5e'
      if(data.popularity >= 0)
        color = '#10b981'
      setChartData({
        labels: data.labels,
        datasets: [
          // Line
          {
            data: data.values,
            fill: true,
            backgroundColor: `rgba(${hexToRGB(color)}, 0.08)`,
            borderColor: color,
            borderWidth: 2,
            tension: 0,
            pointRadius: 0,
            pointHoverRadius: 3,
            pointBackgroundColor: color,
            clip: 20,
          },
        ],
      })
    }
  }, [data]);

  return (
    <div className="flex flex-col col-span-full sm:col-span-6 xl:col-span-3 bg-white shadow-1 rounded-sm border border-slate-200">
      <div className="px-5 pt-5">
        <header>
          <h3 className="text-sm font-semibold text-slate-500 uppercase mb-1">
            <span className="text-slate-800">Usage over Time</span>
          </h3>

          <div className="text-2xl font-bold text-slate-800 mb-1">{total} campaigns</div>
          <div className="text-sm">
              <span className={`font-medium ${popularity>=0?'text-emerald-500':'text-rose-500'}`}>
                {popularity}% {popularity>=0?'more':'less'} popular</span> this week
          </div>
        </header>
      </div>
      {/* Chart built with Chart.js 3 */}
      <div className="grow">
        {/* Change the height attribute to adjust the chart height */}
        {chartData!=null?<LineChart data={chartData} width={286} height={98} />:
          <div className="sm:flex justify-items-center w-full mt-4">
            <div className="m-auto text-center">
              <svg className="animate-spin h-5 w-full" viewBox="0 0 100 100">
                <circle cx="50" cy="50" r="45" stroke="#F7699F" strokeWidth="6" fill="transparent" strokeLinecap="round"
                        strokeDasharray="283" strokeDashoffset="75"/>
              </svg>
            </div>
          </div>
        }
      </div>
    </div>
  );
}

export default FilterTrendCard;
